// 로그인 토큰 — DESIGN §5 고정 키 localStorage["centium.token"] (감사기가 이 키로 주입한다)
import { useSyncExternalStore } from "react";

export const TOKEN_KEY = "centium.token";
export const ME_KEY = "centium.me";

export type Me = { id: string; name: string; admin: boolean };
type Payload = { sid: string; adm: boolean; iat: number; exp: number };

const listeners = new Set<() => void>();
const emit = () => listeners.forEach((f) => f());

function readRaw(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

/** 서명 확인은 서버가 한다. 여기선 누구 토큰인지·만료됐는지만 읽는다 */
export function payloadOf(token: string | null): Payload | null {
  if (!token) return null;
  try {
    const b = token.split(".")[0].replace(/-/g, "+").replace(/_/g, "/");
    const bin = atob(b + "===".slice((b.length + 3) % 4));
    const p = JSON.parse(new TextDecoder().decode(Uint8Array.from(bin, (c) => c.charCodeAt(0)))) as Payload;
    if (!p.sid || (p.exp && p.exp < Date.now())) return null;
    return p;
  } catch {
    return null;
  }
}

export function getToken(): string | null {
  const t = readRaw();
  return payloadOf(t) ? t : null;
}

export function setSession(token: string, me: Me) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ME_KEY, JSON.stringify(me));
  } catch { /* 저장 차단 — 이번 탭에서만 유지 */ }
  emit();
}

export function clearSession() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ME_KEY);
  } catch { /* 무시 */ }
  emit();
}

export function cachedMe(): Me | null {
  const p = payloadOf(readRaw());
  if (!p) return null;
  try {
    const m = JSON.parse(localStorage.getItem(ME_KEY) || "null") as Me | null;
    if (m && m.id === p.sid) return m;
  } catch { /* 무시 */ }
  return { id: p.sid, name: "", admin: !!p.adm };
}

export function useToken(): string | null {
  return useSyncExternalStore(
    (f) => {
      listeners.add(f);
      const onStorage = (e: StorageEvent) => { if (e.key === TOKEN_KEY) f(); };
      window.addEventListener("storage", onStorage);
      return () => { listeners.delete(f); window.removeEventListener("storage", onStorage); };
    },
    getToken,
  );
}
